'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Tabs_module = require('../styles/Tabs.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description TabPane component.
 *
 * @component
 * @example
 * ```jsx
 * <TabPane key="tab-2" title="Tab">Content</TabPane>
 * ```
 */
const TabPane = React__namespace.forwardRef((props, ref) => {
    const { className, children, title: _, ...restProps } = props;
    const cx = reactUtils.useStyles(Tabs_module.default);
    const classNames = cx(className, 'pane');
    return (
    // @ts-ignore
    React__namespace.createElement("div", { ref: ref, "data-qa": "TabPane", className: classNames, ...restProps }, children));
});
TabPane.defaultProps = {};
TabPane.displayName = 'TabPane';

exports.TabPane = TabPane;
//# sourceMappingURL=TabPane.js.map
